import { userConstants } from '../_constants';
import Cookies from 'universal-cookie';

const initialState = determineAuthState();

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.user
      };
    case userConstants.LOGIN_FAILURE:
      return determineAuthState();
    case userConstants.LOGOUT:
      return determineAuthState();
    case userConstants.DELETE_ACCOUNT_REQUEST:
      return {
        deleting: true
      };
    case userConstants.DELETE_ACCOUNT_SUCCESS:
      return determineAuthState();
    case userConstants.DELETE_ACCOUNT_FAILURE:
      return determineAuthState();
    default:
      return determineAuthState();
  }
}

function determineAuthState() {
  let user = JSON.parse(localStorage.getItem('user'));

  if (!user) {

    const cookies = new Cookies();
    if (!cookies.get('user')) {
      let user_json = { _id: "guest",
        email: "unauthenticated-" + (new Date().valueOf()),
        first_name: "Guest",
        last_name: "",
        cabinet: [],
        access_level: 0
      };
      cookies.set('user', user_json, {path: '/'});
    }
    user = cookies.get('user');
    return { loggedIn: false, user }
  } else {
    return { loggedIn: true, user: user.user }
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/authentication.reducer.js